import React from 'react';

// const HASHTAG_REGEX = new RegExp('(?<=\#)(.*?)(?=\#)+/g')
// const HASHTAG_REGEX = /\#[\w\u0590-\u05ff]+/g;

// FIXME: la siguiente expresion regular no se comporta como deberia.
// Resultado experado:  #MATCH# no_match #MATCH#
// Resultado actual:  #MATCH# MATCH #MATCH#
// const HASHTAG_REGEX = /(?<=\#)(.*?)(?=\#)/mg;
// eslint-disable-next-line no-useless-escape
const HASHTAG_REGEX = /(?<=\#)([a-zA-Z_-]*)(?=\#)/gm;

// eslint-disable-next-line no-useless-escape
const HANDLE_REGEX = /\@[\w]+/g;

// eslint-disable-next-line no-unused-vars
export function handleStrategy(contentBlock, callback, contentState) {
  // console.log("HandleStrategy");
  findWithRegex(HANDLE_REGEX, contentBlock, callback);
}

// eslint-disable-next-line no-unused-vars
export function hashtagStrategy(contentBlock, callback, contentState) {
  // console.log("Hashtag Strategy");
  findWithRegex(HASHTAG_REGEX, contentBlock, callback);
}

export function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText();
  let matchArr, start;

  let count = 0;
  while ((matchArr = regex.exec(text)) !== null && count < 100) {
    count++;
    // This is necessary to avoid infinite loops with zero-width matches
    if (matchArr.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    // console.log("Match");
    // console.log(matchArr);
    // The result can be accessed through the `m`-variable.
    // eslint-disable-next-line no-unused-vars
    matchArr.forEach((match, groupIndex) => {
      // console.log(`Found match, group ${groupIndex}: ${match}`);
    });
    start = matchArr.index;
    // console.log("inicio", start);
    // console.log("fin",start+matchArr[0].length);
    callback(start, start + matchArr[0].length);
  }
}

export const HandleSpan = props => {
  return (
    <span style={styles.handle} data-offset-key={props.offsetKey}>
      {props.children}
    </span>
  );
};

export const HashtagSpan = props => {
  return (
    <span style={styles.hashtag} data-offset-key={props.offsetKey}>
      {props.children}
    </span>
  );
};

export const styles = {
  root: {
    fontFamily: "'Helvetica', sans-serif",
    padding: 20,
    minHeight: 70,
  },
  editor: {
    border: '1px solid #ddd',
    cursor: 'text',
    fontSize: 16,
    minHeight: 70,
    padding: 10,
  },
  button: {
    marginTop: 10,
    textAlign: 'center',
  },
  handle: {
    color: 'rgba(98, 177, 254, 1.0)',
    direction: 'ltr',
    unicodeBidi: 'bidi-override',
  },
  hashtag: {
    color: 'rgba(95, 184, 138, 1.0)',
  },
};
